import { render, staticRenderFns } from "./demandHall.vue?vue&type=template&id=22eca84e&scoped=true&"
import script from "./demandHall.vue?vue&type=script&lang=js&"
export * from "./demandHall.vue?vue&type=script&lang=js&"
import style0 from "./demandHall.vue?vue&type=style&index=0&id=22eca84e&lang=scss&scoped=true&"
import style1 from "./demandHall.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eca84e",
  null
  
)

export default component.exports